import { User } from 'irc-framework';

export interface InterfaceTab {
    key: string;
    name: string;
    type: tabType;
    messages: IRCMessage[];
    users?: User[] | null;
}

export enum tabType {
    SETTINGS = 0,
    STATUS = 1,
    CHANNEL_LIST = 2,
    CHANNEL = 3,
    QUERY = 4
}

export enum IRCMessageType {
    DEFAULT = 0,
    SYSTEM = 1,
    ERROR = 2,
    NOTICE = 3,
    ACTION = 4,
    WHOIS = 5
}

export interface IRCMessage {
    timestamp: Date;
    type: IRCMessageType;
    sender?: string;
    content: string;
}

export interface IRCConnectionSettings {
    server: string;
    port: number;
    nickname: string;
    channels: string[];
    nickservPassword?: string;
}

export interface IRCConnectionState {
    isConnected: boolean;
    reconnectAttempts: number;
    maxReconnectAttempts: number;
}

export const IRC_EVENT = {
    CONNECTING: 'connecting',
    CONNECTED: 'connected',
    DISCONNECTED: 'disconnected',
    REGISTERED: 'registered',
    RECONNECTING: 'reconnecting',
    CLOSE: 'close',
    SOCKET_CONNECTED: 'socket connected',
    SOCKET_CLOSE: 'socket close',
    SOCKET_ERROR: 'socket error',
    DEBUG: 'debug',
    RAW: 'raw',
    ACTION: 'action',
    CHANNEL_INFO: 'channel info',
    CHANNEL_LIST: 'channel list',
    CHANNEL_LIST_END: 'channel list end',
    CTCP_REQUEST: 'ctcp request',
    CTCP_RESPONSE: 'ctcp response',
    IRC_ERROR: 'irc error',
    JOIN: 'join',
    KICK: 'kick',
    MODE: 'mode',
    MOTD: 'motd',
    NICK: 'nick',
    NICK_IN_USE: 'nick in use',
    NICK_INVALID: 'nick invalid',
    NOTICE: 'notice',
    PART: 'part',
    PRIVMSG: 'privmsg',
    QUIT: 'quit',
    TOPIC: 'topic',
    USERLIST: 'userlist',
    WHOIS: 'whois',
    AWAY: 'away',
    BACK: 'back',
    BANLIST: 'banlist',
    INVITELIST: 'invitelist',
    EXCEPTLIST: 'exceptlist',
    TOPICSETBY: 'topicsetby',
    ACCOUNT: 'account',
    USER_UPDATED: 'user updated',
    USER_INFO: 'user info',
    WHOWAS: 'whowas',
    WHOLIST: 'wholist',
    MONITORLIST: 'monitorlist',
    USERS_ONLINE: 'users online',
    USERS_OFFLINE: 'users offline',
    WALLOPS: 'wallops',
    TAGMSG: 'tagmsg',
    INVITED: 'invited',
    INVITE: 'invite',
    BATCH_START: 'batch start',
    BATCH_END: 'batch end',
    CAP_LS: 'cap ls',
    CAP_ACK: 'cap ack',
    CAP_NAK: 'cap nak',
    CAP_LIST: 'cap list',
    CAP_NEW: 'cap new',
    CAP_DEL: 'cap del',
    LOGGEDIN: 'loggedin',
    LOGGEDOUT: 'loggedout',
    SASL_FAILED: 'sasl failed',
    INFO: 'info',
    HELP: 'help',
    CHANNEL_REDIRECT: 'channel_redirect',
    SERVER_OPTIONS: 'server options',
    PING: 'ping',
    PONG: 'pong',
    DISPLAYED_HOST: 'displayed host',
} as const;